import { track } from '@repo/ui/src/services/analytics/utils';
import { productClicked, productListViewed } from '@repo/ui/src/services/analytics';
import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';
import { ProductProps } from '@repo/ui/src/types';

interface Props {
  product: ProductProps | ProductProps[];
  cart_id?: string;
  altSize?: string;
  list_name?: string;
  list_id?: string;
  position?: number;
  quantity?: number;
  coupon_name?: Array<string>;
  locale: string;
}

type Types = 'PRODUCT_CLICKED' | 'PRODUCT_LIST_VIEWED';

const normalizeProduct = (product: ProductProps, locale: string) => ({
  affiliation: 'website',
  brand: 'Traeger',
  locale,
  category: product?.category,
  currency: product?.currency,
  description: product?.description,
  image_url: product?.mainImageUrl,
  name: product?.title,
  price: product?.price,
  product_id: product?.sku,
  sku: product?.sku,
  url: `${publicRuntimeConfig.base}${product?.productUrl}`,
  variant: undefined,
  position: product?.listPosition,
  coupon_name: product?.promotionId,
  quantity: product?.quantity,
  in_stock: product?.isOrderable,
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const types: Record<Types, (props: any, options?: any, callback?: any) => void> = {
  PRODUCT_CLICKED: productClicked,
  PRODUCT_LIST_VIEWED: productListViewed,
};

export const logProduct = async (type: Types, { product, list_name, locale, ...rest }: Props) => {
  if (Array.isArray(product)) {
    const normalizedProducts = product.map((p) => normalizeProduct(p, locale));
    track(types[type], { products: normalizedProducts, url: window?.location?.href, ...rest });
  } else {
    track(types[type], { ...normalizeProduct(product, locale), list_name });
  }
};
